import { useState, useCallback } from "react";
import type { TaskManagerDTO } from "~/types/api-custom";

export const useTaskFormState = (task?: TaskManagerDTO) => {
  const isEditMode = !!task;

  const [formData, setFormData] = useState<Partial<TaskManagerDTO>>(() => ({
    id: task?.id,
    name: task?.name || "",
    brandId: task?.brandId,
    workflowId: task?.workflowId,
    folder: undefined,
    path: task?.path || "",
    active: task?.active ?? true,
    taskFields: task?.taskFields || [],
  }));

  const selectedBrandId = formData.brandId ?? task?.brandId ?? null;
  const selectedWorkflowId = formData.workflowId ?? task?.workflowId;
  const currentFolderId = formData.folder?.id ?? null;

  const updateFormField = useCallback(
    <K extends keyof TaskManagerDTO>(field: K, value: Partial<TaskManagerDTO>[K]) => {
      setFormData((prev) => ({ ...prev, [field]: value }));
    },
    []
  );

  return {
    isEditMode,
    formData,
    setFormData,
    selectedBrandId,
    selectedWorkflowId,
    currentFolderId,
    updateFormField,
  };
};
